import type { ApiClient } from './types.js';
import { mockClient } from './mock.js';
import { realClient } from './real.js';

/**
 * 切换 mock / real：
 *   默认 mock（开发时不依赖 BFF 也能玩）
 *   `VITE_API_MODE=real pnpm -F web dev` 切真
 */
const mode = import.meta.env.VITE_API_MODE === 'real' ? 'real' : 'mock';

export const apiClient: ApiClient = mode === 'real' ? realClient : mockClient;
export const API_MODE = mode;
